import API from 'services/TAPS_API';

export default function submitQSA(data) {
  return API.request({
    method: 'POST',
    url: '/notification/qesIssue/draft',
    data,
  });
}
